export default __webpack_public_path__ + "static/media/contact@2x.91f1aef4.jpg";